module.exports = __webpack_public_path__ + "img/m4.48130898.png";